// import { Button, Card, Form, Col, message, Select } from "antd";
import React, { useEffect, useRef, useState } from "react";
import Webcam from "react-webcam";
import axios from "axios";
import imageCompression from "browser-image-compression";

import { getFullFaceDescription } from "../../../faceUtil";
import {
  DEFAULT_WEBCAM_RESOLUTION,
  inputSize,
  webcamResolutionType,
} from "../../../globalData";
import { drawFaceRect } from "../../../utils/drawFaceRect";
import { useDispatch, useSelector } from "react-redux";
import { REPORT_CREATE_REQUESTED } from "redux/actions";
import { CREATE_FACE_PHOTO_REQUESTED } from "redux/actions";
import Card from "components/Card/Card";
import { Button, Select } from "@material-ui/core";
import { Form } from "formik";
import { FILE_UPLOAD_URL } from "scripts/const";
import { TENANT } from "scripts/const";
import { CLEAR_ERROR } from "redux/actions";
import SweetAlert from "react-bootstrap-sweetalert";

const { Option } = Select;

export const UploadFromWebcam = ({ galleryRefetch, countRefetch, loading }) => {
  const [camWidth, setCamWidth] = useState(DEFAULT_WEBCAM_RESOLUTION.width);
  const [camHeight, setCamHeight] = useState(DEFAULT_WEBCAM_RESOLUTION.height);
  const [inputDevices, setInputDevices] = useState([]);
  const [selectedWebcam, setSelectedWebcam] = useState();
  const [isUploading, setIsUploading] = React.useState(false);
  const [file2, setFile2] = React.useState(null);
  const dispatch = useDispatch();
  const currentUser = useSelector((state) => state.login.loginUser.detail);

  const [fullDesc, setFullDesc] = useState(null);

  const [faceDescriptor, setFaceDescriptor] = useState([]);

  const [detectionCount, setDetectionCount] = useState(0);
  const [previewImage, setPreviewImage] = useState("");
  const [confirmAlert, setAlert] = React.useState(null);

  const [waitText, setWaitText] = useState("");

  const webcamRef = useRef();
  const canvasRef = useRef();

  const handleSelectWebcam = (value) => {
    setSelectedWebcam(value);
  };
  const handleWebcamResolution = (value) => {
    webcamResolutionType.map((type) => {
      if (value === type.label) {
        setCamWidth(type.width);
        setCamHeight(type.height);
      }
    });
  };

  useEffect(() => {
    navigator.mediaDevices.enumerateDevices().then(async (devices) => {
      let inputDevice = await devices.filter(
        (device) => device.kind === "videoinput"
      );
      setInputDevices({ ...inputDevices, inputDevice });
    });
  }, []);

  useEffect(() => {
    function capture() {
      if (
        typeof webcamRef.current !== "undefined" &&
        webcamRef.current !== null &&
        webcamRef.current.video.readyState === 4
      ) {
        setPreviewImage(webcamRef.current.getScreenshot());

        const videoWidth = webcamRef.current.video.videoWidth;
        const videoHeight = webcamRef.current.video.videoHeight;

        // Set canvas height and width
        canvasRef.current.width = videoWidth;
        canvasRef.current.height = videoHeight;

        // 4. TODO - Make Detections
        // e.g. const obj = await net.detect(video);

        // Draw mesh
        getFullFaceDescription(webcamRef.current.getScreenshot(), inputSize)
          .then((data) => {
            setFullDesc(data);
            setFaceDescriptor(data[0]?.descriptor);
            setWaitText("");
          })
          .catch((err) => {
            setWaitText(
              "Preparing face matcher and device setup, please wait..."
            );
          });
        const ctx = canvasRef.current.getContext("2d");

        drawFaceRect(fullDesc, ctx);
      }
    }

    let interval = setInterval(() => {
      capture();
    }, 700);

    return () => clearInterval(interval);
  });

  const handleSubmit = () => {
    setIsUploading(true);
    uploadImage((remoteFileUrl) => {
      dispatch({
        type: CREATE_FACE_PHOTO_REQUESTED,
        payload: {
          photoData: previewImage,
          faceDescriptor: faceDescriptor.toString(),
          photoURL: remoteFileUrl,
        },
      });
      setAlert(
        <SweetAlert
          success
          title="Success"
          style={{ display: "block", marginTop: "0px" }}
          onConfirm={() => {
            setAlert(null);
          }}
          onCancel={() => setAlert(null)}
          // confirmBtnCssClass={classes.button + " " + classes.success}
        >
          {"Upload success"}
        </SweetAlert>
      );
    });
    setIsUploading(false);
  };

  function dataURLtoBlob(dataurl) {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    const n = bstr.length;
    const u8arr = new Uint8Array(n);

    for (let i = 0; i < n; i++) {
      u8arr[i] = bstr.charCodeAt(i);
    }

    return new Blob([u8arr], { type: mime });
  }
  function uploadImage(callback) {
    const fileUploadUrl = FILE_UPLOAD_URL;

    let remoteFileUrl = null;
    const blob = dataURLtoBlob(previewImage);
    if (blob instanceof Blob) {
      const fileName = currentUser.firstName + ".jpeg";
      const options = {
        maxSizeMB: 1,
        maxWidthOrHeight: 1024,
        useWebWorker: true,
      };
      imageCompression(blob, options)
        .then(function (compressedFile) {
          axios
            .post(fileUploadUrl, {
              name: fileName,
              folder: `${TENANT}/facegallery/${currentUser.id}`,
            })
            .then(function (response) {
              const responseBody = response.data;
              const formData = new FormData();
              Object.keys(responseBody.fields).forEach((key) => {
                formData.append(key, responseBody.fields[key]);
              });
              formData.append("file", compressedFile);
              const uploadURL = responseBody.url;
              remoteFileUrl = responseBody.fileUrl;
              axios
                .post(uploadURL, formData)
                .then(function () {
                  callback(remoteFileUrl);
                })
                .catch(function (error) {
                  // setIsSaving(false);
                  console.log("Image Upload error: ", error);
                });
            })
            .catch(function (error) {
              // setIsSaving(false);
              console.log("Image Upload error: ", error);
            });
        })
        .catch(function (error) {
          // setIsSaving(false);
          console.log("Error: ", error.message);
        });
    } else {
      dispatch({
        type: CLEAR_ERROR,
      });
      // setIsSaving(false);
    }
  }

  return (
    <Card>
      <p style={{ fontSize: "18px" }}>{waitText}</p>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {confirmAlert}
        <Webcam
          muted={true}
          ref={webcamRef}
          audio={false}
          width={camWidth}
          height={camHeight}
          screenshotFormat="image/jpeg"
          videoConstraints={{
            deviceId: selectedWebcam,
          }}
          mirrored
        />
        <canvas
          ref={canvasRef}
          style={{
            position: "absolute",
            textAlign: "center",
            zindex: 8,
            width: camWidth,
            height: camHeight,
          }}
        />
      </div>
      {previewImage && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <h3>Previous Capture: </h3>
          <img
            src={previewImage}
            alt="Capture"
            style={{ width: "200px", height: "200px" }}
          />
          <div style={{ marginTop: "10px" }}>
            <Button
              type="primary"
              onClick={handleSubmit}
              disabled={
                isUploading ||
                loading ||
                (fullDesc && fullDesc.length !== 1) ||
                (faceDescriptor && faceDescriptor.length !== 128)
              }
              loading={isUploading}
            >
              Save
            </Button>
          </div>
        </div>
      )}
    </Card>
  );
};
